import { render } from "./LangBar.vue?vue&type=template&id=27420caa"
import script from "./LangBar.vue?vue&type=script&lang=js"
export * from "./LangBar.vue?vue&type=script&lang=js"

import "./LangBar.vue?vue&type=style&index=0&id=27420caa&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__